import { useCallback, useState } from 'react';
import { downloadFile } from '@utils/customers/download-file';

import type { FileDownloadModalStatus, UseCheckTicketDownloadReturn } from './use-check-ticket-download.type';
import { getTicketDownloadStatus } from './use-get-ticket-download-status';

export const useCheckTicketDownload = (): UseCheckTicketDownloadReturn => {
  const [modalStatus, setModalStatus] = useState<FileDownloadModalStatus>('idle');

  const closeModal = useCallback(() => {
    setModalStatus('idle');
  }, []);

  const checkAndDownload = useCallback(async (token: string, urlOrCallback: string | (() => void)) => {
    setModalStatus('downloading');

    try {
      const status = await getTicketDownloadStatus(token);

      if (status.isAvailable) {
        if (typeof urlOrCallback === 'string') {
          const response = await fetch(urlOrCallback);
          if (!response.ok) {
            setModalStatus('not-available');
            return;
          }
          const blob = await response.blob();
          downloadFile(blob, 'pdf', `ticket-${token}`);
        } else {
          urlOrCallback();
        }
        setModalStatus('idle');
      } else {
        setModalStatus('not-available');
      }
    } catch {
      setModalStatus('not-available');
    }
  }, []);

  return {
    checkAndDownload,
    downloadModalProps: {
      status: modalStatus,
      onClose: closeModal,
    },
  };
};
